<template>
  <div class="ride-workflow-map" v-if="workflow">
    <div class="map-wrapper" id="ride-workflow-map">
      <div :id="mapID" class="map" />
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet.locatecontrol";
import "leaflet.awesome-markers";

export default {
  name: "RideWorkflowMap",
  props: {
    workflow: Object,
  },
  data() {
    return {
      mapID: "ride-workflow-map-map",
      map: null,
      warning: null,
      straightLine: null,
      layer: null, // main layer
      fallbackRadius: 10000,
    };
  },
  computed: {
    business() {
      return this.workflow.business;
    },
    pickupAreaPolygon() {
      return this.workflow.data.pickup_area_polygon;
    },
    pickupAreaRadius() {
      return this.workflow.data.pickup_area_radius || this.fallbackRadius;
    },
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(this.business, 16);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        maxZoom: 19, //minZoom
      }).addTo(this.map);

      this.map.zoomControl.remove();
      var position = { position: "bottomright" };
      L.control.zoom(position).addTo(this.map);

      this.layer = L.featureGroup().addTo(this.map);

      this.drawUserLocation();

      var stationIcon = L.AwesomeMarkers.icon({
        icon: "store-alt",
        markerColor: "pink",
      });
      var businessMarker = L.marker(this.business, { icon: stationIcon });
      businessMarker.addTo(this.layer);
      var opts = { closeButton: false, autoPan: true };
      businessMarker.bindPopup(`<i>Station</i><br>${this.business.name}`, opts);

      var polygon = this.drawPickupAreaPolygon();

      var group = new L.featureGroup([businessMarker, polygon]);
      var padding = { padding: [50, 50] };
      this.map.fitBounds(group.getBounds(), padding);
    },
    drawPickupAreaPolygon() {
      var coords = this.circlePolygonCoords(); // default is radius
      if (this.pickupAreaPolygon) coords = this.pickupAreaPolygon; // if polygon set
      var geojson = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: coords, //   coordinates: JSON.parse(this.pickupAreaPolygon),
        },
      };
      console.log("draw", geojson);
      var style = {
        color: "#20d2ef",
        weight: 2,
        opacity: 0.3,
      };
      var polygon = L.geoJSON(geojson, { style: style }).addTo(this.map);
      var opts = { closeButton: false, autoPan: true };
      polygon.bindPopup(`Pickup Area`, opts);
      return polygon;
    },
    circlePolygonCoords() {
      var radiusMeters = this.pickupAreaRadius; //100;
      // if (this.pickupAreaRadius) radiusMeters = this.pickupAreaRadius;
      const circleToPolygon = require("circle-to-polygon");
      const coordinates = [this.business.lon, this.business.lat]; //[lon, lat]
      const numberOfEdges = 32; //optional that defaults to 32
      var circle = circleToPolygon(coordinates, radiusMeters, numberOfEdges);
      return circle.coordinates;
    },
    drawUserLocation() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.layer);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    fitToUserLocation() {
      var padding = { padding: [50, 50] };
      this.map.fitBounds(this.layer.getBounds(), padding);
      setTimeout(() => this.userMarker.openPopup(), 1000);
    },
  },
};
</script>

<style scoped>
/* .wrapper {
  position: absolute;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background-color: #2693da;
  z-index: 1102;
} */
.map-wrapper {
  position: absolute;
  left: 0;
  height: calc(100vh - 360px);
  width: 100vw;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
  /* border: 1px solid lightgrey; */
}
.tag {
  position: absolute;
  top: 0;
  /* right: 0; */
  font-size: 0.8em;
  width: 100vw;
  z-index: 1222;
}
</style>

<style lang="scss">
#ride-workflow-map-map {
  .leaflet-control-locate {
    border-radius: 50%;
  }
  .leaflet-control-locate a {
    border-radius: 50%;
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    color: grey;
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .pulse {
    animation: shadow-pulse 2s infinite;
  }
  @keyframes shadow-pulse {
    0% {
      box-shadow: 0 0 0 0px #2693da;
    }
    100% {
      box-shadow: 0 0 0 4px #2692da55;
    }
  }
}
</style>